module.exports = __webpack_public_path__ + "img/pcIndex.4b61ac1e.png";